import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/AdminDeleteUserButton';
// FOR ONE GRAPHQL QUERY
export const DELETE_USER = defineAsyncActionTypes(`${prefix}/DELETE_USER`);



// WEBPACK FOOTER //
// ./src/store/graphql/AdminDeleteUserButton/action-types.js